import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SelectOption } from '@platform/types';
import {
  calculateApiTotalPrice,
  calculateMausPrice,
  calculateSupportTotalPrice,
  CONTACT_MAIL,
  getDefaultAccountPlanConfigV2,
  getDefaultPlanConfigV2,
} from '@emma-pages/user/plan/user-plan.helper';
import {
  AccountPlanConfigurationV2,
  isPlanConfigurationV2,
  Plan,
  PLAN_CONTACT_TYPE,
  PLAN_TYPE,
  PlanConfigurationV2,
  PlanContactInfo,
  PlanContactMail,
} from 'emma-common-ts/emma';
import { orderBy } from 'lodash';

@Component({
    selector: 'emma-request-plan-configurator-modal',
    templateUrl: './emma-request-plan-configurator-modal.component.html',
    standalone: false
})
export class EMMARequestPlanConfiguratorModalComponent implements OnInit {
  @ViewChild('form', { static: false }) public form!: NgForm;
  @Output() $close = new EventEmitter<void>();
  @Output() $confirmation = new EventEmitter<PlanContactInfo>();
  @Output() $contact = new EventEmitter<PlanContactMail>();

  privacySwitch = false;

  @Input() contractedPlan: Plan | undefined;
  @Input() contractedAccountPlanConfig: AccountPlanConfigurationV2 = getDefaultAccountPlanConfigV2();
  @Input() allVolumeMaus: SelectOption[] = [];
  @Input() plans: Plan[] = [];
  contractedPlanConfiguration: PlanConfigurationV2 = getDefaultPlanConfigV2();

  contractedPlanName = '';
  planLocalize = $localize`Plan`;
  contractedVolumeMaus = 0;
  contractedBasePrice = 0;

  reducedVolumeMaus = this.allVolumeMaus;
  reducedPlans: SelectOption[] = [];
  selectedPlan = PLAN_TYPE.GROWTH;
  selectedMaus = 0;

  observation = '';
  newPlanSelectedLabel = '';
  newPrice = 0;

  ngOnInit(): void {
    if (this.contractedPlan && this.contractedAccountPlanConfig) {
      const contractedPlanOrder = this.contractedPlan.order;
      this.contractedPlanName = this.contractedPlan.name;
      this.contractedVolumeMaus = this.contractedAccountPlanConfig.retentionAdquiredTotal;
      this.contractedPlanConfiguration = this.contractedPlan.configuration as PlanConfigurationV2;
      this.reducedPlans = orderBy(this.plans, 'order', 'asc')
        .filter((plan) => isPlanConfigurationV2(plan.configuration) && plan.order <= contractedPlanOrder)
        .map((plan) => {
          return {
            label: `${this.planLocalize} ${plan.name}`,
            value: plan.planType,
          };
        });

      this.contractedBasePrice = calculateMausPrice(
        this.contractedAccountPlanConfig.retentionAdquiredTotal,
        this.contractedPlanConfiguration.retentionRanges
      );

      this.selectedPlan = this.contractedPlan.planType;
    }
  }

  calculateProductsTotal(): void {
    const apiTotalPrice = calculateApiTotalPrice(
      this.contractedBasePrice,
      this.contractedAccountPlanConfig,
      this.contractedPlanConfiguration
    );

    const supportTotalPrice = calculateSupportTotalPrice(
      this.contractedBasePrice,
      this.contractedAccountPlanConfig,
      this.contractedPlanConfiguration
    );

    this.newPrice = this.contractedBasePrice + apiTotalPrice + supportTotalPrice;
  }

  generateNewPlanInfo(): void {
    const newPlanSelected = this.reducedPlans.find((cs) => cs.value === this.selectedPlan);
    this.newPlanSelectedLabel = newPlanSelected?.label || '';
    this.contractedBasePrice = calculateMausPrice(
      this.selectedMaus,
      this.contractedPlanConfiguration.retentionRanges
    );
    this.calculateProductsTotal();
  }

  onPlanChange(): void {
    this.generateNewPlanInfo();
  }

  onMausChange(): void {
    this.generateNewPlanInfo();
  }

  canSend(): boolean {
    return Boolean(this.form?.valid);
  }

  onCloseButton(): void {
    this.$close.emit();
  }

  onConfirmButton(): void {
    if (this.contractedAccountPlanConfig) {
      this.$contact.emit({
        observation: this.observation,
        public: false,
        type: PLAN_CONTACT_TYPE.DOWNGRADE,
        contactFromSection: CONTACT_MAIL.DOWNGRADE_PLAN,
        selectedPlan: this.selectedPlan,
        planConfig: {
          ...this.contractedAccountPlanConfig,
          totalPrice: this.newPrice,
          retentionAdquiredTotal: this.selectedMaus,
        },
      });
    }
  }
}
